import { UnsubscribeSubcriptionService } from './../../../../services/unsubscribe-subcription.service';
import { ToastrService } from 'ngx-toastr';
import { take } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';

import * as fromGCSubTask from './../../green-card-store/reducers/greencard-subtask.reducer';
import * as DirtyForm from '../../../../app-state/actions/dirty-form.actions';
import { SubTaskDetails } from '../../../../data/models/subTaskDetails.model';
import { NotifyCodeNoAction } from '../../../../data/constants/notification-type-code';
import { PetitionerService } from '../../../../services/petitioner.service';
import { GreenCardService } from '../../green-card-service/green-card.service';
import { CustomErrorToastComponent } from 'custom-error-toast';

@Component({
  selector: 'app-green-card-send-notification',
  templateUrl: './green-card-send-notification.component.html',
  styleUrls: ['./green-card-send-notification.component.scss']
})
export class GreenCardSendNotificationComponent implements OnInit, OnDestroy {
  petitionAuditLogForm: FormGroup;
  recipientList: any[];
  resetForm: {
    to: number;
    message: string;
  } = {
      to: null,
      message: null
    };
  subcriptions: Subscription[] = [];
  subTaskDetails: SubTaskDetails;
  userType: string;
  selectedReceiverType: string;
  title: string;

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private store: Store<fromGCSubTask.State>,
    private petitionerService: PetitionerService,
    private toastrService: ToastrService,
    private greenCardService: GreenCardService,
    private unsubscribeSubcriptionService: UnsubscribeSubcriptionService
  ) {
    this.title = config.data.title;
  }

  ngOnInit() {
    this.userType = sessionStorage.getItem('userTypeRole');
    this.petitionAuditLogForm = new FormGroup({
      to: new FormControl(null, Validators.required),
      message: new FormControl(null, Validators.required)
    });
    this.subcriptions[this.subcriptions.length] = this.petitionAuditLogForm.statusChanges.subscribe(() => {
      if (this.petitionAuditLogForm.dirty) {
        this.store.dispatch(new DirtyForm.MarkDirtyFormAction({ dirty: true }));
      } else {
        this.store.dispatch(new DirtyForm.MarkCleanFormAction({ dirty: false }));
      }
    });
    this.store.select(fromGCSubTask.getGCSubTaskDetails)
      .pipe(take(1))
      .subscribe(gcSubTaskDetails => {
        if (gcSubTaskDetails) {
          this.subTaskDetails = gcSubTaskDetails;
          this.getRecipientList();
        }
      });
  }

  getRecipientList() {
    this.recipientList = [{
      id: null,
      name: 'Select',
      type: null
    }];
    switch (this.userType) {
      case 'Attorney':
        if (this.subTaskDetails.beneficiaryId) {
          this.recipientList.push({
            id: this.subTaskDetails.beneficiaryId,
            name: `${this.subTaskDetails.beneficiaryDetails.firstName} ${this.subTaskDetails.beneficiaryDetails.middleName} ${this.subTaskDetails.beneficiaryDetails.lastName}-Beneficiary`,
            type: 'Beneficiary'
          });
        }
        if (this.subTaskDetails.immSpecialistId) {
          this.recipientList.push({
            name: this.subTaskDetails.preparePetitionerName ? this.subTaskDetails.preparePetitionerName + '-Petitioner' : 'Petitioner',
            type: 'Petitioner',
            id: this.subTaskDetails.immSpecialistId
          });
        }
        break;
      case 'Petitioner':
        if (this.subTaskDetails.beneficiaryId) {
          this.recipientList.push({
            id: this.subTaskDetails.beneficiaryId,
            name: `${this.subTaskDetails.beneficiaryDetails.firstName} ${this.subTaskDetails.beneficiaryDetails.middleName} ${this.subTaskDetails.beneficiaryDetails.lastName}-Beneficiary`,
            type: 'Beneficiary'
          });
        }
        if (this.subTaskDetails.preparerAttorneyId) {
          this.recipientList.push({
            name: this.subTaskDetails.preparerAttorneyName ? this.subTaskDetails.preparerAttorneyName + '-Attorney' : 'Attorney',
            type: 'Attorney',
            id: this.subTaskDetails.preparerAttorneyId
          });
        }
        break;
      case 'Beneficiary':
        if (this.subTaskDetails.immSpecialistId) {
          this.recipientList.push({
            name: this.subTaskDetails.preparePetitionerName ? this.subTaskDetails.preparePetitionerName + '-Petitioner' : 'Petitioner',
            type: 'Petitioner',
            id: this.subTaskDetails.immSpecialistId
          });
        }
        if (this.subTaskDetails.preparerAttorneyId) {
          this.recipientList.push({
            name: this.subTaskDetails.preparerAttorneyName ? this.subTaskDetails.preparerAttorneyName + '-Attorney' : 'Attorney',
            type: 'Attorney',
            id: this.subTaskDetails.preparerAttorneyId
          });
        }
        break;
    }
  }

  onClose() {
    this.greenCardService.onStepCloseDirtyCheck().pipe(take(1))
      .subscribe(response => {
        if (response) {
          this.petitionAuditLogForm.reset(this.resetForm);
          this.ref.close();
        }
      });
  }

  onRecipientChange() {
    if (this.petitionAuditLogForm.value.to) {
      this.selectedReceiverType = (this.petitionAuditLogForm.get('to').value) === this.subTaskDetails.beneficiaryId ?
        'Beneficiary' :
        this.userType === 'Petitioner' ? 'Attorney' : 'Petitioner';
    } else {
      this.selectedReceiverType = '';
    }
  }

  onSubmit() {
    // IM-7024 : Sending companyID if reciever type is attorney
    let companyID;
    if(this.selectedReceiverType === 'Beneficiary' )
    {
      companyID = this.subTaskDetails.companyId;
    }else {
      companyID = this.subTaskDetails.attorneyId;
    }

    const payload = {
      beneficiaryId: this.selectedReceiverType === 'Beneficiary' ? this.petitionAuditLogForm.value.to : null,
      channelType: 'APP',
      companyId: companyID,
      data: `{"superTaskId": ${this.subTaskDetails.superTaskId}}`,
      employeeId: this.selectedReceiverType === 'Beneficiary' ? null : this.petitionAuditLogForm.value.to,
      id: 0,
      notificationType: NotifyCodeNoAction.TASK_AUDIT,
      notifyAllBeneficiaries: false,
      notifyAllEmployees: false,
      priority: '',
      text: this.petitionAuditLogForm.value.message,
      title: this.title
    };
    this.petitionerService.postNotification(payload)
      .pipe(take(1))
      .subscribe(respObj => {
        if (respObj.status === 200) {
          this.petitionAuditLogForm.reset();
          this.toastrService.success(respObj.message, 'Success');
        } else {
          CustomErrorToastComponent.showErrorToast(this.toastrService, respObj.message);
        }
      });
  }

  ngOnDestroy(): void {
    this.store.dispatch(new DirtyForm.MarkCleanFormAction({ dirty: false }));
    this.unsubscribeSubcriptionService.onUnSubscribe(this.subcriptions);
  }

}
